import { render, staticRenderFns } from "./EditPersonalDetailsModal.vue?vue&type=template&id=3b4e4327&scoped=true&"
import script from "./EditPersonalDetailsModal.vue?vue&type=script&lang=js&"
export * from "./EditPersonalDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonalDetailsModal.vue?vue&type=style&index=0&id=3b4e4327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e4327",
  null
  
)

export default component.exports